import React, { useEffect } from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  BarChart,
  Bar
} from 'recharts';

interface DataVisualizationProps {
  data: any[];
  type: 'line' | 'bar';
  xAxis: string;
  yAxis: string;
  title?: string;
}



const DataVisualization: React.FC<DataVisualizationProps> = ({
  data,
  type,
  xAxis,
  yAxis,
  title
}) => {
  const renderChart = () => {
    
    switch (type) {
      case 'line':
        return (
          <LineChart data={data.slice(0, 100)} >
            <CartesianGrid strokeDasharray="3 3"   />
            <XAxis dataKey={xAxis} />
            <YAxis dataKey={yAxis}/>
            <Tooltip />
            <Legend />
            <Line type="monotone" dataKey={yAxis} stroke="#8884d8" />
          </LineChart>
        );
      case 'bar':
        return (
          <BarChart data={data.slice(0, 100)}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey={xAxis} />
            <YAxis />
            <Tooltip />
            <Legend />
            <Bar dataKey={yAxis} fill="#8884d8" />
          </BarChart>
        );
      default:
        return <></>;
    }
  };

  return (
    <div className="data-visualization">
      {title && <h3>{title}</h3>}
      <ResponsiveContainer width="100%" height={400}  >
        {renderChart()}
      </ResponsiveContainer>
    </div>
  );
};

export default DataVisualization; 